import React, { useEffect, useState } from 'react'

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'

import { Container, MessageDrawer } from '../../components'
import { TopNavigation } from './TopNavigation'
import { UnitHistories } from './UnitHistories'
import { UnitSideBar } from './UnitSideBar'
import {
    useAppDispatch,
    useMessageDrawer,
    useRootInfrastructure,
} from '../../hooks'
import { getStatusGroupList, getStatusList, setUnits } from '../../store'

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            backgroundColor: theme.palette.grey[100],
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            height: 'calc(100vh - 104px)',
        },
        mainContent: {
            flex: 1,
            display: 'flex',
            minHeight: 0,
            overflow: 'hidden',
        },
        contentArea: {
            flex: 1,
            minHeight: 0,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
        },
    }),
)

interface SelectedUnitNotes {
    id: number
    name: string
    channel_id: number
    unread_unit_notes: number
}

export const UnitsHome = () => {
    const classes = useStyles()
    const [selectedAreaId, setSelectedAreaId] = useState<number | null>(null)
    const [searchQuery, setSearchQuery] = useState('')
    const [unitNotesOpen, setUnitNotesOpen] = useState(false)
    const [selectedUnit, setSelectedUnit] = useState<SelectedUnitNotes | null>(
        null,
    )

    const dispatch = useAppDispatch()
    const { setChannel } = useMessageDrawer()
    const { unitList } = useRootInfrastructure(false)

    useEffect(() => {
        dispatch(getStatusGroupList({}))
        dispatch(getStatusList({}))
    }, [])

    const openUnitNotes = (unit: SelectedUnitNotes) => {
        if (unit.channel_id) {
            setChannel(unit.channel_id)
        }
        setSelectedUnit(unit)
        setUnitNotesOpen(true)

        if (unit.unread_unit_notes !== 0) {
            const newUnitList = unitList?.map((u) =>
                u.id === unit.id ? { ...u, unread_unit_notes: 0 } : u,
            )
            dispatch(setUnits(newUnitList ?? []))
            setSelectedUnit({ ...unit, unread_unit_notes: 0 })
        }
    }

    return (
        <Container className={classes.root}>
            <TopNavigation
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
            />

            <Container className={classes.mainContent}>
                <UnitSideBar
                    selectedAreaId={selectedAreaId}
                    setSelectedAreaId={setSelectedAreaId}
                    searchQuery={searchQuery}
                    onOpenUnitNotes={openUnitNotes}
                />

                <Container className={classes.contentArea}>
                    <UnitHistories selectedAreaId={selectedAreaId} />
                </Container>
            </Container>

            {selectedUnit && (
                <MessageDrawer
                    open={unitNotesOpen}
                    title={`Unit Notes ${selectedUnit.name}`}
                    onClose={() => {
                        setUnitNotesOpen(false)
                        setSelectedUnit(null)
                    }}
                    onCreateMessage={() => {
                        const newUnitList = unitList?.map((u) =>
                            u.id === selectedUnit.id
                                ? {
                                      ...u,
                                      unit_notes_msg_count:
                                          u.unit_notes_msg_count + 1,
                                  }
                                : u,
                        )
                        dispatch(setUnits(newUnitList ?? []))
                    }}
                />
            )}
        </Container>
    )
}
